import * as React from "react";
import { observer } from "mobx-react";
import { ScreenMode } from "../../../models/enums";
import SeekerStore from "../../../stores/seekerStore";
import { Category } from "../../../models/category";
import OpportunityStore from "../../../stores/opportunityStore";
import * as Opportunity from "../../../models/opportunity";
import FeaturedContent from "../../../models/featuredContent";
import { FeatureLevel, EmptyId } from "../../../models/enums";
import { sort } from "../../../utils/data";
import { Row, Col, Grid } from "react-flexbox-grid";
import Slider from "react-slick";
import * as s from "./featureContent.css";

@observer
export default class FeaturedContentDisplay extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  renderContent(content: Array<FeaturedContent>, cls: string): JSX.Element[] {
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const items: JSX.Element[] = [];
    sort(content, "order").map((fc:FeaturedContent, i:number):void => {
      const url: string = fc.link || "#";
      let imgUrl: string = fc.level === FeatureLevel.Tertiary && mode === ScreenMode.Tablet ? `/image/${fc.tabletImageId}` : `/image/${fc.imageId}`;
      /* fallback if no tablet view is set up */
      if (imgUrl === `/image/${EmptyId}` || imgUrl === null) {
          imgUrl = `/image/${fc.imageId}`;
        }   
        const target: string = fc.external ? "_blank" : null;
          if (fc.external) {
            items.push(<div data-index={i} key={i}><a href="#" onClick={() => { this.props.store.viewState.showLink(url); }} ><img src={imgUrl} className={cls} /></a></div>);
          } else {
            items.push(<div data-index={i} key={i}><a href={url} ><img src={imgUrl} className={cls} /></a></div>);
          }
    });
    return items;
  }
  render(): JSX.Element {
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const primaryItems: Array<FeaturedContent> = this.props.store.viewState.featuredContent.filter((fc: FeaturedContent): boolean => { return fc.level === FeatureLevel.Primary });
    const secondaryItems: Array<FeaturedContent> = this.props.store.viewState.featuredContent.filter((fc: FeaturedContent): boolean => { return fc.level === FeatureLevel.Secondary });
    const tertiaryItems: Array<FeaturedContent> = this.props.store.viewState.featuredContent.filter((fc: FeaturedContent): boolean => { return fc.level === FeatureLevel.Tertiary });
    
    return (
      <Grid className={s.container}>
        <Row>
          {primaryItems.length > 0 && <Col xs={12} sm={12} md={12} lg={8} xl={8} className={s.primaryContainer}>
            <Slider
              dots={mode !== ScreenMode.Mobile}
              autoplay={primaryItems.length > 1 ? true : false}
              autoplaySpeed={6000}
              draggable={true}
              swipeToSlide={primaryItems.length > 1 ? true : false}
              slidesToScroll={1}
              swipe={true}
              nextArrow={null} 
              prevArrow={<CustomNoPrevArrow />}>
              {this.renderContent(primaryItems, s.imgPrimary)}
              {primaryItems.length === 1 && <div></div>}
            </Slider>
          </Col>}
          <Col xs={12} sm={12} md={12} lg={4} xl={4} >
            <Row>
              {secondaryItems.length > 0 && <Col xs={12} sm={12} md={7} lg={12} xl={12} className={s.secondaryContainer} >
                <Slider
                  dots={false}
                  autoplay={false}
                  draggable={false}
                  swipeToSlide={false}
                  slidesToShow={1}
                  slidesToScroll={1}
                  nextArrow={null}
                  prevArrow={<CustomNoPrevArrow />}>
                  {this.renderContent(secondaryItems, s.imgSecondary)}
                  {secondaryItems.length === 1 && <div></div>}
                </Slider>
              </Col>}
              {tertiaryItems.length > 0 && <Col xs={12} sm={12} md={5} lg={12} xl={12} className={s.tertiaryContainer}>
                <Slider
                  dots={false}
                  autoplay={false}
                  draggable={false}
                  swipeToSlide={false}
                  slidesToShow={1}
                  slidesToScroll={1}
                  nextArrow={null}
                  prevArrow={<CustomNoPrevArrow />}>
                  <div>{this.renderContent(tertiaryItems, s.imgTertiary)}</div>
                  {tertiaryItems.length === 1 && <div></div>}
                </Slider>
              </Col>}
            </Row>
          </Col>
        </Row>
      </Grid>
    );
  }
}


function CustomNextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={s.slickArrow}
      style={{
        ...style,
        display: 'block',
        position: 'absolute',
        top: '50%',
        background: '#0000004a',
        height: '100%',
        width: '60px',
        right: '0',
        transform: 'translateY(-50%)',
        zIndex: '1'
      }}
      onClick={onClick}
    ></div>
  );
}

function CustomNoPrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={s.noPrevArrow}
      style={{
        ...style,
      }}
      onClick={onClick}
    ></div>
  );
}

function CustomNoNextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={s.noNextArrow}
      style={{
        ...style,
      }}
      onClick={onClick}
    ></div>
  );
}










// WEBPACK FOOTER //
// ./src/components/widgets/featuredContent/index.tsx